import { toPairs } from 'lodash';
import { sortNamesBy } from 'logic/sortNames';
import { SelectHTMLAttributes, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

require('./ListSelectField.css');

export type Props = SelectHTMLAttributes<HTMLSelectElement> & {
    id?: string;
    className?: string;
    size: number;
    required?: boolean;
    label?: string;
    labelKey?: string;
    options: Record<string, string>;
    showNone?: boolean; // True if "(none)" should be a visible selection
    noneValue?: string; // The value to use when None is allowed and nothing is selected
};

export const ListSelectField = ({ required, id, className, label, labelKey, options, disabled, value, noneValue = '', showNone = false, ...otherProps }: Props) => {
    const { t } = useTranslation();

    const sortedOptions = useMemo(() => {
        return toPairs(options)
            .map(pair => ({
                value: pair[0],
                label: pair[1],
            }))
            .sort(sortNamesBy(p => p.label));
    }, [ options ]);

    return (
        <div className={ `${required ? 'required' : ''} field list-select-field ${className || ''}` }>
            { (label || labelKey) &&
                <label htmlFor={ id } className={ disabled ? 'disabled' : '' }>
                    { label || t(labelKey!) }
                </label>
            }
            <select
                id={ id }
                disabled={ disabled }
                value={ showNone ? value || noneValue : value || undefined }
                { ...otherProps }
            >
                { showNone &&
                    <option
                        className="_none"
                        value={ noneValue }
                    >
                        { t('NONE')}
                    </option>
                }
                { sortedOptions.map(o =>
                    <option
                        key={ o.value }
                        value={ o.value }
                    >
                        { o.label }
                    </option>
                ) }
            </select>
        </div>
    );
};
